import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-order-paid-date-view',
  templateUrl: './order-paid-date-view.component.html',
  styleUrls: ['./order-paid-date-view.component.scss'],
})
export class OrderPaidDateViewComponent {
  @Input() paidDate: string;
}

